import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaStringDefinition } from './TypedDefinition'

export const SchemaStringPlugin = createSchemaPlugin(
  'Schema.String',
  SchemaStringDefinition
)
